import React, { useEffect } from 'react';
import queryString from 'query-string';
import { useAppDispatch } from 'stores/type';
import { Splash } from 'views/components/molecules/Splash';
import { useHistory } from 'react-router-dom';
import { DefaultTemplate } from 'views/templates/DefaultTemplate';
import { useIntl } from 'react-intl';
import { closeDialog, showDialog } from 'stores/dialogSlice';
import { localeIds } from 'locals';
import { Redirect } from 'react-router-dom';
import { setExceptionError } from 'stores/errorSlice';
import { ROUTER_PATH } from 'views/constants';
import { useDevice } from 'views/hooks/useDevice';
import { ApplicationError } from 'models/Error';

export const SAMLPage: React.FC = () => {
  const history = useHistory();
  const intl = useIntl();

  const dispatch = useAppDispatch();
  const { loginFromSAML } = useDevice();

  const onetimeToken = queryString.parse(location.search)[
    'ios_spa_onetime_token'
  ] as string;

  useEffect(() => {
    if (!onetimeToken) {
      return;
    }

    loginFromSAML(onetimeToken)
      .then(() => {
        history.replace('/apps');
      })
      .catch((e) => {
        if (e instanceof ApplicationError) {
          dispatch(
            showDialog({
              content: e.originalMessage || localeIds.api.error.general,
              defaultAction: {
                label: intl.formatMessage({
                  id: localeIds.dialog.ok,
                }),
                callback: () => {
                  dispatch(closeDialog());
                  history.replace(ROUTER_PATH.samlLogin);
                },
              },
            })
          );
        } else dispatch(setExceptionError(e));
      });
  }, [dispatch, history, intl, loginFromSAML, onetimeToken]);

  if (onetimeToken) {
    return (
      <DefaultTemplate headerText="">
        <Splash />
      </DefaultTemplate>
    );
  } else {
    return <Redirect to={ROUTER_PATH.samlLogin} />;
  }
};
